module.exports = __webpack_public_path__ + "static/img/icon-black.29cb912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-black.png
// module id = 177
// module chunks = 1